import Skeleton from '@/components/Skeleton';
import { isEqual } from 'lodash';
import { useEffect, useState } from 'react';
import ToolTip from '@/components/Tooltip';
import { TrashSimple, WarningOctagon } from '@phosphor-icons/react';

export const DrillDownTables = ({
  bkpSelTables,
  selected,
  setSelected,
  loading,
  logoList,
  tablePaths,
  setSelTables,
  setBkpSelTables,
  setTablePaths,
  pathsLoading,
  pathDetails,
  primarySource,
}) => {
  const [hovering, setHovering] = useState('');
  const [tooltipShow, setTooltipShow] = useState(true);

  useEffect(() => {
    if (bkpSelTables.length > 0) {
      if (isEqual(selected, {})) {
        setSelected(bkpSelTables[0]);
      } else {
        if (
          bkpSelTables.findIndex((tab) => tab.tableId === selected.tableId) ===
          -1
        ) {
          setSelected(bkpSelTables[0]);
        }
      }
    } else {
      setSelected({});
    }
  }, [bkpSelTables]);

  return (
    <div
      className="flex flex-col w-full h-full px-3 py-2.5 overflow-y-auto"
      onScroll={() => {
        setTooltipShow(false);
      }}
    >
      {pathsLoading || loading ? (
        <div className="flex flex-col w-full h-full">
          <Skeleton
            variant="rounded"
            width={'40%'}
            height="19px"
            className="bg-pv-neutral-grey-100 mb-2"
          />
          {Array.from({ length: 5 }).map((_, ind) => {
            return (
              <div className="flex items-center gap-1 p-3" key={ind}>
                <Skeleton
                  variant="rounded"
                  width={'20px'}
                  height="20px"
                  className="bg-pv-neutral-grey-100"
                />
                <Skeleton
                  variant="rounded"
                  width={ind % 2 === 1 ? '40%' : '60%'}
                  height="22px"
                  className="bg-pv-neutral-grey-100"
                />
              </div>
            );
          })}
        </div>
      ) : bkpSelTables.length > 0 ? (
        <div className="flex flex-col w-full h-full">
          <span className="text-pv-text-secondary-text font-medium text-xs pb-2">
            Drill-Down Tables:
          </span>
          {bkpSelTables.map((tab, ind) => {
            return (
              <>
                {ind > 0 && (
                  <span className="w-full h-[1px] bg-pv-neutral-grey-100" />
                )}
                <div
                  className={`flex items-center w-full justify-between gap-2 hover:bg-pv-primary-primary-50 p-3 border-l-3 h-[46px] cursor-pointer ${selected.tableId === tab.tableId ? `border-pv-primary-primary-500 bg-pv-primary-primary-50 font-medium` : `border-transparent`}`}
                  key={ind}
                  onMouseEnter={() => {
                    setHovering(tab.tableName);
                  }}
                  onMouseLeave={() => {
                    setHovering('');
                  }}
                  onClick={() => {
                    setSelected(tab);
                  }}
                >
                  <button
                    className={`flex items-center gap-1`}
                    style={{
                      width:
                        hovering === tab.tableName
                          ? 'calc(100% - 42px)'
                          : '100%',
                    }}
                  >
                    <img
                      src={logoList[tab.platform]}
                      className="w-4"
                      style={{
                        aspectRatio: 1,
                      }}
                    />
                    <ToolTip
                      placement="top"
                      title={tab.tableName}
                      displayTooltipOnOverflow
                      tooltipActive={tooltipShow}
                    >
                      <span
                        className="overflow-hidden text-ellipsis whitespace-nowrap"
                        onMouseEnter={() => {
                          setTooltipShow(true);
                        }}
                      >
                        {tab.tableName}
                      </span>
                    </ToolTip>
                  </button>
                  {hovering === tab.tableName ? (
                    <ToolTip
                      placement="top"
                      title="Remove drill-down"
                      tooltipActive={tooltipShow}
                    >
                      <button
                        className="hover:bg-pv-primary-primary-100 p-[5px] rounded"
                        onClick={(e) => {
                          e.stopPropagation();
                          setTablePaths((prev) => {
                            let temp = structuredClone(prev);
                            delete temp[tab.tableName];
                            return temp;
                          });
                          setBkpSelTables((prev) => {
                            let temp = structuredClone(prev);
                            temp = temp.filter(
                              (table) => table.tableName !== tab.tableName
                            );
                            setSelTables(temp);
                            return temp;
                          });
                        }}
                        onMouseEnter={() => {
                          setTooltipShow(true);
                        }}
                      >
                        <TrashSimple size={12} />
                      </button>
                    </ToolTip>
                  ) : tab?.tableName !== primarySource &&
                    (!pathDetails?.mergePaths?.[tab?.tableName]?.paths ||
                      (Array.isArray(
                        pathDetails?.mergePaths?.[tab?.tableName]?.paths
                      ) &&
                        pathDetails.mergePaths[tab.tableName].paths.length ===
                          0)) ? (
                    <WarningOctagon
                      size={16}
                      className="text-pv-error-error-text mr-[2.5px]"
                    />
                  ) : null}
                </div>
              </>
            );
          })}
        </div>
      ) : (
        <div className="flex w-full h-full items-center justify-center">
          <p className="w-[80%] text-center text-pv-text-secondary-text font-medium text-xs">
            Add drill-down from different tables or import directly from
            existing definitions
          </p>
        </div>
      )}
    </div>
  );
};
